import React, { createContext, useState } from "react";
import { UserDto } from "./dto/user";

// Define the shape of the context
interface UserContextProps {
  user: UserDto | null;
  setUser: React.Dispatch<React.SetStateAction<UserDto | null>>;
}

// Create the context
export const UserContext = createContext<UserContextProps>({
  user: null,
  setUser: () => {},
});

// Create a provider component
export const UserProvider = ({ children }: { children: React.ReactNode }) => {
  const [user, setUser] = useState<UserDto | null>(null);

  return (
    <UserContext.Provider value={{ user, setUser }}>
      {children}
    </UserContext.Provider>
  );
};
